module.exports = __webpack_public_path__ + "static/media/budweiser_boomerang03.4422bcb9.webm";